import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';
import get from 'lodash/get';
import Ad from '../ad/ad';
import FCLink from '../fc_link/fc_link';
import asyncPostNativeAdActions from '../../../redux/actions/post/async_post_native_ad_actions';
import adLoaded from '../../../redux/action_creators/ads_action_creator';
import ClientSideWrapper from '../client_side_wrapper/client_side_wrapper';

const tempSponsoredArticles = [
  {
    image:
      'https://images.fastcompany.net/image/upload/w_350,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/wp-cms/uploads/2014/11/Sierra-Maddy-Founders-copy.jpg',
    eyebrow: 'PRESENTED BY INSTAGRAM',
    title: 'Turning followers into customers, one tap at a time',
    url:
      'https://www.fastcompany.com/90433776/turning-followers-into-customers-one-tap-at-a-time'
  },
  {
    image:
      'https://images.fastcompany.net/image/upload/w_350,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/wp-cms/uploads/2019/10/BEB_08212019_Selects_pr_21.jpg',
    eyebrow: 'PRESENTED BY CUMMINS',
    title:
      'Battery Electric Buses: the innovative technology that’s re-energizing urban mass transit',
    url:
      'https://www.fastcompany.com/90424050/battery-electric-buses-the-innovative-technology-thats-re-energizing-urban-mass-transit'
  },
  {
    image:
      'https://images.fastcompany.net/image/upload/w_350,ar_16:9,c_fill,g_auto,f_auto,q_auto,fl_lossy/wp-cms/uploads/2019/10/shutterstock_1075182245.jpg',
    eyebrow: 'PRESENTED BY STAPLES',
    title: 'Are you a design thinker? To keep innovating, you should be.',
    url:
      'https://www.fastcompany.com/90420471/are-you-a-design-thinker-to-keep-innovating-you-should-be'
  }
];

class Megatron extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      activeNative: true,
      // sponsoredCardData: null,
      tempSponsoredCardData: null
    };

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.swiperResize = this.swiperResize.bind(this);
  }

  componentWillMount() {
    // random 0 - 2
    const randomSponorCard = Math.floor(Math.random() * 3);
    this.setState({
      tempSponsoredCardData: tempSponsoredArticles[randomSponorCard]
    });
  }

  componentDidMount() {
    window.addEventListener('resize', this.swiperResize);
  }

  componentWillReceiveProps(nextProps) {
    const nativeAdHomepageTileLoaded = get(
      nextProps,
      'adsLoaded.native_homepagefeature'
    );

    if (nativeAdHomepageTileLoaded) {
      this.setNativeAd();
      this.props.dispatchAdLoadedEvent('native_homepagefeature', false);
    }

    const newPostNativeAd = get(
      nextProps,
      'postNativeAd.homepageFeaturedTile.posts'
    );

    if (
      get(newPostNativeAd, 'length') !==
        get(this.props, 'postNativeAd.homepageFeaturedTile.posts.length') &&
      get(newPostNativeAd, 'length')
    ) {
      this.setState({
        // sponsoredCardData: newPostNativeAd
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.swiperResize);
  }

  onMouseEnter(index) {
    this.setState({ activeIndex: index });
    this.swiper.slideTo(index);
    this.swiper.autoplay.stop();
  }

  onMouseLeave() {
    this.swiper.autoplay.start();
  }

  setNativeAd() {
    const nativeAdsData = get(window, 'fc_ads.native.homepageFeaturedTile');

    if (!nativeAdsData) {
      return;
    }

    // Check if it's native_type === homepageFeaturedTile
    if (get(nativeAdsData, 'native_type') === 'homepageFeaturedTile') {
      if (
        !get(nativeAdsData, 'article_ids') &&
        !get(nativeAdsData, 'campaign_name') &&
        !get(nativeAdsData, 'clickthrough_url')
      ) {
        return;
      }

      this.props.dispatchPostNativeAd(nativeAdsData, get(this.props, 'config'));
    }
  }

  swiperResize() {
    this.swiper.update();
  }

  render() {
    const { activeIndex, activeNative, tempSponsoredCardData } = this.state;
    const { articles, config, combinedAdModel } = this.props;
    const settings = {
      effect: 'fade',
      autoplay: {
        delay: 4000
      },
      on: {
        slideChangeTransitionStart: () => {
          const { activeIndex: ai } = this.swiper;
          if (ai === 2 && activeNative) {
            this.setState({
              activeNative: false
            });
          }
          this.setState({ activeIndex: ai });
        }
      }
    };

    return (
      <Fragment>
        <div className="megatron">
          <Swiper
            {...settings}
            ref={node => {
              if (node) this.swiper = node.swiper;
            }}
          >
            {articles.map(({ featured_image: img }) => (
              <div key={img.source} className="megatron__slide">
                <div
                  className="megatron__slide-background"
                  style={{
                    backgroundImage: `url(${img.source.replace(
                      'upload/',
                      'upload/w_2480,ar_16:9,c_fill,g_auto:body,f_auto,q_auto:best/'
                    )})`
                  }}
                />
              </div>
            ))}
          </Swiper>
          <div className="megatron__articles">
            {articles.map(({ title, categories, link }, index) => (
              <article
                key={link}
                className={`megatron__article ${
                  activeIndex === index ? 'megatron__article--active' : ''
                }`}
                onMouseEnter={() => this.onMouseEnter(index)}
                onMouseLeave={this.onMouseLeave}
              >
                <FCLink title={title} to={link} config={config}>
                  {categories.map(({ name }) => <span key={name}>{name}</span>)}
                  <h2>{title}</h2>
                </FCLink>
              </article>
            ))}
            {tempSponsoredCardData && (
              <div
                className={`megatron__article megatron__article--native ${
                  activeNative ? 'megatron__article--native__active' : ''
                }`}
              >
                <a href={tempSponsoredCardData.url}>
                  <div className="img-container">
                    <img
                      src={tempSponsoredCardData.image}
                      alt={tempSponsoredCardData.title}
                    />
                  </div>
                  <span>{tempSponsoredCardData.eyebrow}</span>
                  <h2>{tempSponsoredCardData.title}</h2>
                </a>
              </div>
            )}
          </div>
        </div>
        <div className="homepage-page__ff-ad-container">
          <ClientSideWrapper showOnlyDesktop={true}>
            <Ad {...combinedAdModel} name="flexiblebillboard_1" />
          </ClientSideWrapper>
        </div>
      </Fragment>
    );
  }
}

Megatron.propTypes = {
  config: PropTypes.shape({}).isRequired,
  articles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  combinedAdModel: PropTypes.shape({}).isRequired,
  dispatchAdLoadedEvent: PropTypes.func.isRequired,
  dispatchPostNativeAd: PropTypes.func.isRequired
};

function mapStateToProps(state = {}) {
  return {
    config: state.config,
    postpage: state.postpage,
    postNativeAd: get(state, 'postNativeAd.data', {}),
    adsLoaded: get(state, 'ads.data')
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchPostNativeAd(nativeAdsData, config) {
      return asyncPostNativeAdActions(dispatch, config, nativeAdsData);
    },

    dispatchAdLoadedEvent(adName, status) {
      dispatch(adLoaded(adName, status));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Megatron);
